import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { PropositionInvestmentConfig } from '../../Models/Domains/Account/PropositionInvestmentConfig';

declare var IS_RUNNING_IN_APP_POOL;

export class InvestmentPermissionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(servicePropositionId: number): Promise<Array<PropositionInvestmentConfig>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/InvestmentPermission/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { servicePropositionId: servicePropositionId }

    return AjaxWrapper.get<Array<PropositionInvestmentConfig>, any>(url, data);
  }
}

